import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faBagel,
  faBaguette,
  faBan,
  faBeerMug,
  faBone,
  faBookOpen as faBookOpenLight,
  faBowlChopsticksNoodles,
  faBowlFood,
  faBowlHot,
  faBowlRice,
  faBowlScoops,
  faBowlSoftServe,
  faBoxArchive as faBoxArchiveLight,
  faBreadLoaf,
  faBreadSliceButter,
  faBurger,
  faBurgerCheese,
  faBurgerFries,
  faBurgerGlass,
  faBurgerLettuce,
  faBurgerSoda,
  faBurrito,
  faCakeCandles,
  faCakeSlice,
  faCalendarDay,
  faCalendar as faCalendarLight,
  faCandyCane,
  faCheeseSwiss,
  faClone,
  faCloud,
  faCookie,
  faCorn,
  faCrab,
  faCroissant,
  faCupStrawSwoosh,
  faCupcake,
  faDollarSign,
  faDonut,
  faEggFried,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faFile,
  faFishFins,
  faFolderOpen,
  faFolderOpen as faFolderOpenLight,
  faFonduePot,
  faFrenchFries,
  faGift as faGiftLight,
  faGlass,
  faHandHoldingDollar as faHandHoldingDollarLight,
  faHotdog,
  faIceCream,
  faImage,
  faImagePolaroid,
  faKey as faKeyLight,
  faLayerGroup,
  faLink,
  faLobster,
  faLollipop,
  faMartiniGlass,
  faMeat,
  faMotorcycle,
  faMugHot,
  faMugSaucer,
  faMugTeaSaucer,
  faPanFood,
  faPancakes,
  faPen as faPenLight,
  faPercent,
  faPie,
  faPizzaSlice,
  faPlus as faPlusLight,
  faPopcorn,
  faPotFood,
  faPretzel,
  faSackDollar,
  faSalad,
  faSandwich,
  faShrimp,
  faSquid,
  faSteak,
  faSushi,
  faSushiRoll,
  faTableCells as faTableCellsLight,
  faTaco,
  faTrash,
  faTurkey,
  faTurnDownLeft as faTurnDownLeftLight,
  faUtensils,
  faVolume,
  faVolumeMute,
  faWhiskeyGlassIce,
  faWineBottle,
  faWineGlass,
  faWineGlassEmpty,
  faCircle1,
} from "@fortawesome/pro-light-svg-icons";

import {
  faAngleDown,
  faChevronDown as faChevronDownSolid,
  faChevronUp as faChevronUpSolid,
  faCircleXmark,
  faStar as faStarSolid,
} from "@fortawesome/free-solid-svg-icons";

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import {
  faArchive,
  faArrowDownBigSmall,
  faBell,
  faBookOpen,
  faCalendar,
  faChartLine,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClock,
  faComment,
  faCreditCard,
  faCreditCardBlank,
  faDownload,
  faEllipsisH,
  faEllipsisV,
  faEnvelopeOpen,
  faFilter,
  faFolder,
  faGift,
  faHamburger,
  faHandHoldingDollar,
  faIdCardClip,
  faImagePolaroid as faImagePolaroidRegular,
  faInfo,
  faInfoCircle,
  faLeaf,
  faListTimeline,
  faList,
  faLock,
  faLongArrowLeft,
  faLongArrowRight,
  faMap,
  faMapMarker,
  faMapMarkerAlt,
  faMessage,
  faMinus,
  faMoneyBillTransfer,
  faPaperPlane,
  faPen,
  faPlus,
  faQrcode,
  faSave,
  faSlidersH,
  faSortSizeUp,
  faSortSizeUpAlt,
  faStar,
  faStore,
  faTableCells,
  faTags,
  faTicketSimple,
  faTimes,
  faTrashAlt,
  faTrash as faTrashRegular,
  faFileUpload,
  faUpload,
  faTurnDownLeft,
  faUser,
  faSpinnerThird,
  faUserPlus,
  faPalette,
  faFolderTree,
} from "@fortawesome/pro-regular-svg-icons";

library.add({
  faMinus,
  faImagePolaroid,
  faPlus,
  faPlusLight,
  faEye,
  faEyeSlash,
  faTrash,
  faTrashAlt,
  faChevronLeft,
  faChevronRight,
  faStore,
  faCreditCard,
  faCreditCardBlank,
  faBookOpen,
  faClock,
  faMap,
  faMapMarkerAlt,
  faChevronUp,
  faChevronDown,
  faMapMarker,
  faSortSizeUp,
  faCalendar,
  faEllipsisV,
  faEllipsisH,
  faPizzaSlice,
  faUtensils,
  faWineGlass,
  faLongArrowLeft,
  faLongArrowRight,
  faTimes,
  faExclamationCircle,
  faCheck,
  faPen,
  faUser,
  faSortSizeUpAlt,
  faStarSolid,
  faBell,
  faVolume,
  faVolumeMute,
  faSave,
  faFilter,
  faLeaf,
  faHamburger,
  faTags,
  faMoneyBillTransfer,
  faAngleDown,
  faClone,
  faCloud,
  faFile,
  faCalendarLight,
  faFolderOpenLight,
  faSquid,
  faSteak,
  faSushi,
  faSushiRoll,
  faTaco,
  faTurkey,
  faWhiskeyGlassIce,
  faWineBottle,
  faWineGlassEmpty,
  faBagel,
  faBaguette,
  faBeerMug,
  faBone,
  faBowlChopsticksNoodles,
  faBowlFood,
  faBowlHot,
  faBowlRice,
  faBowlScoops,
  faBowlSoftServe,
  faBreadLoaf,
  faBreadSliceButter,
  faBurgerCheese,
  faBurgerFries,
  faBurgerGlass,
  faBurgerLettuce,
  faBurger,
  faBurgerSoda,
  faBurrito,
  faCakeCandles,
  faCakeSlice,
  faCandyCane,
  faCheeseSwiss,
  faCookie,
  faCorn,
  faCrab,
  faCroissant,
  faCupcake,
  faCupStrawSwoosh,
  faDonut,
  faEggFried,
  faFishFins,
  faFonduePot,
  faGlass,
  faFrenchFries,
  faHotdog,
  faIceCream,
  faLobster,
  faLollipop,
  faMartiniGlass,
  faMeat,
  faMugHot,
  faMugSaucer,
  faMugTeaSaucer,
  faPancakes,
  faPanFood,
  faPie,
  faTableCells,
  faPopcorn,
  faPotFood,
  faPretzel,
  faSalad,
  faShrimp,
  faSandwich,
  faBan,
  faHandHoldingDollar,
  faTicketSimple,
  faStar,
  faSlidersH,
  faListTimeline,
  faList,
  faGift,
  faQrcode,
  faChartLine,
  faSackDollar,
  faPercent,
  faMotorcycle,
  faFolder,
  faArchive,
  faComment,
  faEnvelopeOpen,
  faArrowDownBigSmall,
  faIdCardClip,
  faTurnDownLeft,
  faImagePolaroidRegular,
  faPenLight,
  faLink,
  faCalendarDay,
  faChevronUpSolid,
  faChevronDownSolid,
  faImage,
  faTrashRegular,
  faTurnDownLeftLight,
  faBoxArchiveLight,
  faGiftLight,
  faFolderOpen,
  faPaperPlane,
  faMessage,
  faWhatsapp,
  faInfo,
  faDownload,
  faInfoCircle,
  faLock,
  faTableCellsLight,
  faCircleXmark,
  faKeyLight,
  faBookOpenLight,
  faHandHoldingDollarLight,
  faDollarSign,
  faLayerGroup,
  faCircle1,
  faFileUpload,
  faUpload,
  faSpinnerThird,
  faUserPlus,
  faPalette,
  faFolderTree,
});

export const Icon = ({
  color = "#4C4C4C",
  name,
  size = "xs",
  regular,
  brand,
  solid,
  light,
  onClick,
}) => {
  let prefix = null;

  switch (true) {
    case light:
      prefix = "fal";
      break;
    case regular:
      prefix = "far";
      break;
    case solid:
      prefix = "fas";
      break;
    case brand:
      prefix = "fab";
      break;
    default:
      prefix = "far";
      break;
  }

  return (
    <FontAwesomeIcon
      icon={[prefix, name]}
      color={color}
      size={size}
      onClick={onClick}
    />
  );
};
